import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

// Check if environment variables are set
const hasValidConfig = url && anon && url !== 'undefined' && anon !== 'undefined';

// In development, allow app to render with mock client if env vars are missing
// In production, this should be set via environment variables
if (!hasValidConfig) {
  if (import.meta.env.DEV) {
    // Only warn once per page load to avoid console spam
    const warnKey = '__supabaseEnvWarned';
    if (!sessionStorage.getItem(warnKey)) {
      console.info('ℹ️ Supabase: Using placeholder client (auth disabled). Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env to enable authentication.');
      sessionStorage.setItem(warnKey, 'true');
    }
  } else {
    // In production, throw error to prevent deployment without proper config
    throw new Error('Missing required Supabase environment variables: VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set');
  }
}

const supabaseUrl = url || 'https://placeholder.supabase.co';
const supabaseAnonKey = anon || 'placeholder-key';

// Single Supabase client with PKCE flow for production-safe OAuth
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce', // Use PKCE flow for OAuth security
  },
});


